<template>
    <div class="w-full md:w-fit">
        <Button
            @click.stop="show = true"
            :disabled="reservation.cannotRefund"
            color="danger-outline"
            size="small"
            iconName="close-circle"
            iconClass="w-4 h-4"
            class="w-full"
        >
            Refund
        </Button>

        <ModalConfirmation
            :show="show"
            :action="submit"
            color="danger"
            title="Are you sure you want to refund this meeting?"
            actionText="Yes, refund"
            :actionProcessing="apiFormRef?.loading.valueOf()"
            @close="show = false"
        >
            <template #content>
                <div class="text-gray-500 text-center">
                    This action is irreversible.
                </div>
            </template>
        </ModalConfirmation>

        <ApiForm
            :url="
                urlFactory.makeNonRecurringMeetingRefundUrl(
                    meeting.id,
                    reservation.id,
                )
            "
            method="POST"
            :disableCatch="false"
            ref="apiFormRef"
        />
    </div>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import Button from '@/Shared/Component/Button.vue'
    import ModalConfirmation from '@/Shared/Component/ModalConfirmation.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import MeetingData from '@/App/Booking/Meeting/Entity/MeetingData'
    import Meeting from '@/App/Booking/Meeting/Entity/Meeting'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import { ResponseJsonKeyEnum } from '@/Shared/AutoGenerated/Main'
    import Reservation from '@/App/Booking/Reservation/Entity/Reservation'

    const emits = defineEmits<{
        onSuccess: [{ meetingData: MeetingData }]
    }>()

    const props = defineProps({
        meeting: {
            type: Object as PropType<Meeting>,
            required: true,
        },
        reservation: {
            type: Object as PropType<Reservation>,
            required: true,
        },
    })

    const show = ref(false)
    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value
            ?.submit()
            ?.then((response: ApiFormResponseType) => {
                show.value = false
                emits('onSuccess', {
                    meetingData: response.getHydratedMeetingData(
                        ResponseJsonKeyEnum.App_Refund_Reservation_MeetingDataData,
                    ),
                })
            })
            ?.catch(() => {
                show.value = false
            })
    }
    const urlFactory = new UrlFactory()
</script>
